// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2dSoA","insightsList":"newBusinessInsightsMenu_insightsList__2tBVn","active":"newBusinessInsightsMenu_active__3qdMx"};